<script setup>
import xMod from '../common/xMod.vue'
import OrderLogin from '@/components/common/OrderLogin.vue'
import Position from '@/components/orders/futures/Position.vue'
import { useUserStore } from '~/store/user'
import { useOrderStore } from '~/store/order'
import { useFutureStore } from '~/store/future'

const { t } = useI18n()
const order = useOrderStore()
const user = useUserStore()
const future = useFutureStore()
const curTab = ref('position')
const params = ref({})
const tabs = computed(() => {
  return [
    {
      title: t('仓位'),
      key: 'position',
      component: Position,
      suffix: future.positionsN,
    },
    {
      title: t('当前委托'),
      key: 'open',
      component: defineAsyncComponent(() => import('@/components/orders/futures/Open.vue')),
      suffix: future.openOrdersN,
      props: { params: params.value },
    },
    {
      title: t('历史委托'),
      key: 'orderHistory',
      component: defineAsyncComponent(() => import('@/components/orders/futures/OrderHistory.vue')),
      props: { params: params.value },
    },
    {
      title: t('成交明细'),
      key: 'tradeHistory',
      component: defineAsyncComponent(() => import('@/components/orders/futures/TradeHistory.vue')),
      props: { params: params.value },
    },
    {
      title: t('平仓盈亏'),
      key: 'profitHistory',
      component: defineAsyncComponent(() => import('@/components/orders/futures/ProfitHistory.vue')),
      props: { params: params.value },
    },
    {
      title: t('强平历史'),
      key: 'liquidHistory',
      component: defineAsyncComponent(() => import('@/components/orders/futures/LiquidHistory.vue')),
      props: { params: params.value },
    },
    {
      title: t('资金流水'),
      key: 'accountAssetFlow',
      component: defineAsyncComponent(() => import('@/components/orders/futures/AccountAssetFlow.vue')),
      props: { params: params.value },
      hideCurrent: true,
    },
  ]
})

const selects = {
  position: ['contractId', 'closeAll'],
  open: ['conditionType', 'contractId', 'cancelAll'],
  orderHistory: ['conditionType', 'contractId'],
  tradeHistory: ['contractId'],
  profitHistory: ['dateSelect', 'side', 'contractId'],
  liquidHistory: ['contractId'],
  accountAssetFlow: ['currencyId'],
}

function handleSearch(searchParams) {
  params.value = { ...searchParams }
}

function tabChange(value) {
  const current = order.current
  order.$reset()
  order.current = current
  if (order.current) {
    order.params.contractId = future.id
  }
  curTab.value = value
}
</script>

<template>
  <div class="min-h-[400px] bg-fillPagePrimary rounded">
    <ClientOnly>
      <xMod need-login :tab="curTab" :tabs="tabs" class="h-full" component-class="pb-4 h-[400px] min-w-full !w-[calc(100vw-304px)]" @tab-change="tabChange">
        <template v-if="user.isLogin" #actions="{ hideCurrent, key }">
          <CommonXCheckbox v-if="!hideCurrent" v-model="order.current">
            <span class="text-xs">{{ $t('隐藏其他交易对') }}</span>
          </CommonXCheckbox>
          <NuxtLink v-if="curTab !== 'position'" class="inline-flex items-center text-textPrimary" :to="localePath(`/my/orders/future/${key}`)">
            {{ $t('查看更多') }}
            <SvgoCommonArrowRight class="w-4 h-4" />
          </NuxtLink>
        </template>
        <template #prefix>
          <OrdersFutureOrderSelects class="my-2" :show-condition-type-n="curTab === 'open'" :selects="selects[curTab]" @search="handleSearch" />
        </template>
        <template #append>
          <ClientOnly>
            <OrderLogin v-if="!user.isLogin" />
          </ClientOnly>
        </template>
      </xMod>
    </ClientOnly>
  </div>
</template>
